import { render, staticRenderFns } from "./RPTrage.vue?vue&type=template&id=223cfb24"
import script from "./RPTrage.vue?vue&type=script&lang=js"
export * from "./RPTrage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports